import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanDeactivateFn } from '@angular/router';

import { PhraseSaveQueueService } from './phrase-save-queue.service';

export const pendingSavesGuard: CanDeactivateFn<unknown> = async () => {
  const saveQueue = inject(PhraseSaveQueueService);
  if (saveQueue.pendingIds().length === 0) return true;

  const snackbar = inject(MatSnackBar);
  const ref = snackbar.open('Saving...', '');
  const saved = await saveQueue.drainAll();
  ref.dismiss();
  if (!saved) {
    snackbar.open('Some changes could not be saved.', '', { duration: 5000 });
  }
  return true;
};
